import { render, staticRenderFns } from "./Bifactor.vue?vue&type=template&id=2ad7135e&scoped=true&"
import script from "./Bifactor.vue?vue&type=script&lang=js&"
export * from "./Bifactor.vue?vue&type=script&lang=js&"
import style0 from "./Bifactor.vue?vue&type=style&index=0&id=2ad7135e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad7135e",
  null
  
)

/* custom blocks */
import block0 from "../locales/views/bifactor.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fjenkins%2Fagent%2Fworkspace%2FCBDS%2FDZXM%2Fhuawei_yun%2FSXJGXM%2F01sxjg_prod_openplatform%2FWorkerJobs%2Fdcost-gcsj-frontend%2Febq%2Ffront-gcsj-login%2Fsrc%2Fcomponents%2FBifactor.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports